// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"460":"d7cc0db1","480":"4a80b286","862":"eef2403a"}[chunkId] + ".chunk.js";
};